'use client';

import { SHOP } from '@/lib/data/shop';
import { isTrading } from '@/lib/opening';
import { useLondonNow } from './useLondonNow';

/**
 * Renders its children only once the shop is trading, and the fallback until
 * then. Before the clock has been read it follows the switch in Shop details
 * alone, which is what the static HTML says too, so server and first client
 * render agree; the opening date is applied once the clock ticks.
 */
export function useTrading(): boolean {
  const now = useLondonNow();
  return now ? isTrading(now, SHOP) : SHOP.trading;
}

export function WhenTrading({
  children,
  fallback = null,
}: {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}) {
  return <>{useTrading() ? children : fallback}</>;
}
